import { ButtonInputWithPopover } from "@msys/ui";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import { useTranslate } from "@tolgee/react";

export function TasksMineFilterButton({
  value,
  setValue,
}: {
  value: boolean;
  setValue: (newValue: boolean) => void;
}) {
  const { t } = useTranslate(["Global"]);

  return (
    <ButtonInputWithPopover
      label={t("Mine", { ns: "Global" })}
      counter={value ? 1 : undefined}
      content={
        <Box
          sx={{
            p: 1,
          }}
        >
          <FormControl component="fieldset" variant="standard">
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    size="medium"
                    checked={value}
                    onChange={(_event, checked) => {
                      setValue(checked);
                    }}
                  />
                }
                label={
                  <Typography variant="body1">
                    {t("Mine", { ns: "Global" })}
                  </Typography>
                }
                sx={{ ml: 0, mr: 0 }}
              />
            </FormGroup>
          </FormControl>
        </Box>
      }
      popoverWidth="md"
    />
  );
}
